import { render, staticRenderFns } from "./EditPlayerSection.vue?vue&type=template&id=2c5584fe"
import script from "./EditPlayerSection.vue?vue&type=script&lang=js"
export * from "./EditPlayerSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports